class Logger {
  static consoleError(message, error) {
    console.error({
      message: message,
      error: error,
      code: error?.code,
      timestamp: new Date().toISOString(),
    });
  }
}

export default Logger;
